var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#18181E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 25L20 29L24 25",
    stroke: "#A5A5A8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20V29",
    stroke: "#A5A5A8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8801 26.09C29.7494 25.4786 30.4014 24.6061 30.7413 23.5991C31.0813 22.5921 31.0915 21.503 30.7705 20.4898C30.4494 19.4766 29.8139 18.5921 28.9561 17.9646C28.0983 17.337 27.0629 16.9992 26.0001 17H24.7401C24.4393 15.8279 23.8765 14.7392 23.0942 13.8161C22.3118 12.8929 21.3302 12.1593 20.2233 11.6703C19.1163 11.1814 17.9129 10.95 16.7036 10.9935C15.4943 11.037 14.3106 11.3543 13.2416 11.9214C12.1726 12.4886 11.2463 13.2908 10.5322 14.2678C9.81821 15.2448 9.33511 16.371 9.11932 17.5617C8.90353 18.7524 8.96067 19.9766 9.28643 21.142C9.6122 22.3074 10.1981 23.3838 11.0001 24.29",
    stroke: "#A5A5A8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportWallet);
export default __webpack_public_path__ + "static/media/import-wallet.fc08ca1eabc8414d6b1b8e6c5b2bf138.svg";
export { ForwardRef as ReactComponent };